import { useEffect, useState } from 'react';

export enum Devices {
  Android = 'Android',
  IOS = 'IOS',
  Desktop = 'Desktop',
  Other = 'Other',
}

export const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState<Devices | null>(null);

  useEffect(() => {
    const userAgent = typeof window !== 'undefined' ? navigator.userAgent : '';
    if (/android/i.test(userAgent)) {
      return setDeviceType(Devices.Android);
    }
    if (
      (/iPad|iPhone|iPod/.test(userAgent) && !/Windows/.test(userAgent)) ||
      // Matches iPads
      (/Macintosh/i.test(userAgent) &&
        navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 1)
    ) {
      return setDeviceType(Devices.IOS);
    }
    if (/Windows|Macintosh|Linux/.test(userAgent)) {
      return setDeviceType(Devices.Desktop);
    }

    return setDeviceType(Devices.Other);
  }, []);

  return deviceType;
};
